import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";
export const initializeDatadog = () => {
  // Check if Datadog is already initialized
  if (datadogRum.getInitConfiguration()) {
    return;
  }

  //   if (process.env.REACT_APP_DATADOG_ENABLED === 'true') { // Since i am not using env variables.. TODO
  datadogRum.init({
    applicationId: "3d842734-36a4-4089-ad78-32f99591f00a",
    clientToken: "pub04ec67dbe2e8870bd46c43732f03c57e",
    site: "us3.datadoghq.com",
    service: "397enbn",
    env: "prod",

    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: "mask-user-input",
    plugins: [reactPlugin({ router: true })],
  });
  datadogRum.startSessionReplayRecording();
  //   }
};;
